import { DateRangeProps, useDateRange } from 'components';
import { useDateRangeV2 } from './useDateRangeV2';
import { endOfDay, endOfWeek, startOfDay, startOfMonth, startOfWeek, subDays, subHours, subMinutes, subWeeks } from 'date-fns';
import { useWidgetDateRange } from 'common/providers';
import { utcToZonedTime } from 'date-fns-tz';
import { timePicker40DaySupportEnabled } from 'constants/machineConfig';

export type UseRangeSelectListOptionsReturnProps = Record<string, DateRangeProps>;

export interface UseRangeSelectListOptionsProps {
  hasProvider?: boolean;
}

export const useRangeSelectListOptionsV2 = (): UseRangeSelectListOptionsReturnProps => {

  const { isInit, timeZone: timezone1 } = useWidgetDateRange();
  const { rightNow, timeZone: timezone2 } = useDateRange();
  const { now: rightNow2, timeZone: timezone3 } = useDateRangeV2();

  const timezone = isInit 
                    ? timezone1 
                    : timezone3 
                        ? timezone3 
                        : timezone2

  let endTime = isInit 
  ? utcToZonedTime(new Date().toISOString(), timezone) 
  : rightNow2  
      ? rightNow2
      : rightNow

  endTime = endTime instanceof Date ? endTime : new Date(endTime);  
  return {
    today: {
      startTime: startOfDay(endTime),
      endTime
    },
    yesterday: {
      startTime: startOfDay(subDays(endTime, 1)),
      endTime: endOfDay(subDays(endTime, 1))
    },
    'this-week': {
      startTime: startOfWeek(endTime),
      endTime
    },
    'last-week': {
      startTime: startOfWeek(subWeeks(endTime, 1)),
      endTime: endOfWeek(subWeeks(endTime, 1))
    },
    'last-2-weeks': {
      startTime: subWeeks(endTime, 2),
      endTime
    },
    'this-month': {
      startTime: startOfMonth(endTime),
      endTime
    },
    'last-30-days': {
      startTime: subDays(endTime, 30),
      endTime
    },
    ...(timePicker40DaySupportEnabled && {
      'last-40-days': {
        startTime: subDays(endTime, 40),
        endTime
      }
    }),
    day: {
      startTime: subDays(endTime, 1),
      endTime
    },
    '2-days': {
      startTime: subDays(endTime, 2),
      endTime
    },
    '3-days': {
      startTime: subDays(endTime, 3),
      endTime
    },
    '15-minutes': {
      startTime: subMinutes(endTime, 15),
      endTime
    },
    '30-minutes': {
      startTime: subMinutes(endTime, 30),
      endTime
    },
    '2-hours': {
      startTime: subHours(endTime, 2),
      endTime
    },
    '4-hours': {
      startTime: subHours(endTime, 4),
      endTime
    },
    '8-hours': {
      startTime: subHours(endTime, 8),
      endTime
    },
    '24-hours': {
      startTime: subHours(endTime, 24),
      endTime
    }
  };
};
